<template>
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="450"
      class="action-private-channel-dialog"
    >
      <v-card v-if="groupAction">
        <v-card-title class="text-h5">
          <span v-if="member">{{ capitalizeFirstLetter($t('chat.contextMenu')[groupAction]) }}</span>
          <span v-else>{{ $t('chat.confirmDialog.title', { channelAction: capitalizeFirstLetter($t('chat.contextMenu')[groupAction]) }) }}</span>
        </v-card-title>
        <br/>
        <v-card-text v-if="group">
          <span v-if="member">
            <span v-html="$t(`chat.confirmDialog.member.message.${groupAction}`, { textColor: this.getTextColor, memberName: member.name, channelName: group.formatName() })"></span>
          </span>
          <span v-else v-html="$t('chat.confirmDialog.message', { channelAction: $t('chat.contextMenu')[groupAction], textColor: this.getTextColor, channelName: group.formatName() })"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            {{ $t('chat.confirmDialog.btn.cancel') }}
          </v-btn>
          <v-btn
            :color="getColor"
            text
            class="action-private-channel-dialog-btn"
            @click="confirmAction()"
          >
            {{ $t(`chat.contextMenu.${groupAction}`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-actionGroupDialog',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      confirmDialog: 'chat/confirmGroupActionDialog',
      group: 'chat/contextMenuGroup',
      groupAction: 'chat/contextMenuGroupAction',
      member: 'chat/contextMenuGroupMember'
    }),
    getColor: function () {
      return this.group?.conversationColorScheme()
    },
    getTextColor: function () {
      return `font-weight-bold ${this.getColor}--text`
    }
  },
  methods: {
    ...mapActions({
      closeDialog: 'chat/closeGroupActionDialog',
      archive: 'chat/archiveGroup',
      delete: 'chat/deleteGroup',
      restore: 'chat/restoreGroup',
      open: 'chat/openGroup',
      close: 'chat/closeGroup',
      kick: 'chat/kickMemberFromGroup',
      addOwner: 'chat/addOwnerToGroup',
      removeOwner: 'chat/removeOwnerFromGroup',
      leave: 'chat/leaveGroup'
    }),

    wordingFromOrTo () {
      return this.groupAction === 'add owner' ? 'to' : 'from'
    },

    confirmAction () {
      switch (this.groupAction) {
        case 'kick':
          this[this.groupAction](this.member?.id)
          break
        case 'add_owner':
          this.addOwner(this.member?.id)
          break
        case 'remove_owner':
          this.removeOwner(this.member?.id)
          break
        default:
          this[this.groupAction]()
      }
    },

    capitalizeFirstLetter (string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1)
    }
  }
}
</script>

<style scoped>
</style>
